export enum UserAccessLevelGroupName {
  ManifestAccessLevelGroup = 'manifestAccessLevelGroup',
  ResultsAccessLevelGroup = 'resultsAccessLevelGroup',
  OrdersAccessLevelGroup = 'ordersAccessLevelGroup',
  AdminAccessLevelGroup = 'adminAccessLevelGroup'
}
